export var Language;
(function (Language) {
    Language["de"] = "de";
    Language["fr"] = "fr";
})(Language || (Language = {}));
export var anyLocationForLanguage = new Map();
anyLocationForLanguage.set(Language.de, 'weltweit');
anyLocationForLanguage.set(Language.fr, 'dans-le-monde-entier');
export default Language;
